import { PlayerAccountApi, PlayerItem, PlayerItemGrouping } from '../../communication/player-account/PlayerAccountApi'

export enum PlayerItemActionsTypes {
    GET_PLAYER_ITEMS_STARTED = 'GET_PLAYER_ITEMS_STARTED',
    GET_PLAYER_ITEMS_SUCCESS = 'GET_PLAYER_ITEMS_SUCCESS',
    GET_PLAYER_ITEMS_FAILURE = 'GET_PLAYER_ITEMS_FAILURE',
	GET_PLAYER_ITEM_GROUPINGS_STARTED = 'GET_PLAYER_ITEM_GROUPINGS_STARTED',
	GET_PLAYER_ITEM_GROUPINGS_SUCCESS = 'GET_PLAYER_ITEM_GROUPINGS_SUCCESS',
	GET_PLAYER_ITEM_GROUPINGS_FAILURE = 'GET_PLAYER_ITEM_GROUPINGS_FAILURE',
}

export type PlayerItemAction =
    | { type: PlayerItemActionsTypes.GET_PLAYER_ITEMS_STARTED }
    | { type: PlayerItemActionsTypes.GET_PLAYER_ITEMS_SUCCESS; payload: { playerItems: PlayerItem[] } }
    | { type: PlayerItemActionsTypes.GET_PLAYER_ITEMS_FAILURE; payload: { error: Error } }
    | { type: PlayerItemActionsTypes.GET_PLAYER_ITEM_GROUPINGS_STARTED }
    | { type: PlayerItemActionsTypes.GET_PLAYER_ITEM_GROUPINGS_SUCCESS; payload: { playerItemGroupings: PlayerItemGrouping[] } }
    | { type: PlayerItemActionsTypes.GET_PLAYER_ITEM_GROUPINGS_FAILURE; payload: { error: Error } }    

const getPlayerItemsStarted = () => ({
	type: PlayerItemActionsTypes.GET_PLAYER_ITEMS_STARTED,
})

const getPlayerItemsSuccess = playerItems => ({
	type: PlayerItemActionsTypes.GET_PLAYER_ITEMS_SUCCESS,
	payload: {
		playerItems,
	},
})

const getPlayerItemsFailure = error => ({
	type: PlayerItemActionsTypes.GET_PLAYER_ITEMS_FAILURE,
	payload: {
		error,
	},
})

const getPlayerItemGroupingsStarted = () => ({
	type: PlayerItemActionsTypes.GET_PLAYER_ITEM_GROUPINGS_STARTED,
})

const getPlayerItemGroupingsSuccess = playerItemGroupings => ({
	type: PlayerItemActionsTypes.GET_PLAYER_ITEM_GROUPINGS_SUCCESS,
	payload: {
		playerItemGroupings,
	},
})

const getPlayerItemGroupingsFailure = error => ({
	type: PlayerItemActionsTypes.GET_PLAYER_ITEM_GROUPINGS_FAILURE,
	payload: {
		error,
	},
})

export const getPlayerItems = () => dispatch => {
	dispatch(getPlayerItemsStarted())
	PlayerAccountApi.getItemsForUser()
		.then(response => dispatch(getPlayerItemsSuccess(response.items)))
		.catch(error => dispatch(getPlayerItemsFailure(error)))
}

export const getPlayerItemGroupings = () => dispatch => {
	dispatch(getPlayerItemGroupingsStarted())
	PlayerAccountApi.getItemGroupingsForUser()
		.then(response => dispatch(getPlayerItemGroupingsSuccess(response.items)))
		.catch(error => dispatch(getPlayerItemGroupingsFailure(error)))
}
